/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add-user': {
    width: 16,
    height: 16,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm0-12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zM22 28H5v-3.1c0-1.4.8-2.7 2.1-3.3 4.6-2.3 10.1-2.7 14.9-1.2v-2.1c-5.2-1.4-11-1-15.8 1.5-2 1-3.2 2.9-3.2 5.1V30h19v-2z"/><path pid="1" d="M32 23h-5v-5h-2v5h-5v2h5v5h2v-5h5z"/>'
  }
})
